import React from 'react';

import { offset } from '@floating-ui/react';
import cx from 'classnames';
import { useDispatch } from 'react-redux';

import Button from 'components/shared/Button';
import Text from 'components/shared/Typography/Text';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { useTooltipDialog } from 'hooks/useTooltipDialog/useTooltipDialog';
import { setAppHasChangesAction } from 'store/unsavedChanges';

import s from './index.module.css';
import { Props } from './types';

function SceneFooter({
  goBack,
  onSubmit,
  loading,
  type = 'default',
  submitButtonLabel = 'Next',
  withTooltipDialog,
}: Props) {
  const dispatch = useDispatch();
  const { isMobile } = useMediaBreakpoints();

  const handleGoBack = () => {
    if (!goBack) return;
    goBack();
    dispatch(setAppHasChangesAction(false));
  };

  const generateTooltipDialog = useTooltipDialog({
    message: (
      <Text size={isMobile ? 'medium' : 'small'} type="brandon" isStrong className={s.messageContainer}>
        Entered information will be lost,
        <br />
        Are you sure you want to continue?
      </Text>
    ),
    options: [{ text: 'No' }, { text: 'Yes', onClick: handleGoBack }],
    floatingOptions: { middleware: [offset(6)] },
    containerClassName: s.modalTooltipContainer,
  });

  const handleOnClick = () => {
    if (withTooltipDialog) {
      return generateTooltipDialog.openTooltip();
    }
    handleGoBack();
  };

  return (
    <div
      className={cx({
        [s.defaultGroupContainer]: type === 'default',
        [s.primaryGroupContainer]: type === 'primary',
      })}
    >
      {goBack && (
        <div className={s.buttonContainer}>
          <div ref={generateTooltipDialog.setReference}>
            <Button type="default" onClick={handleOnClick} disabled={loading}>
              Go Back
            </Button>
          </div>

          {generateTooltipDialog.TooltipDialog()}
        </div>
      )}

      <Button onClick={onSubmit} loading={loading}>
        {submitButtonLabel}
      </Button>
    </div>
  );
}

export { SceneFooter };
